import React, { useEffect } from "react";
import LoginForm from "../../components/LoginForm";
import { Image } from "antd"
import { useNavigate } from "react-router-dom";
import "./index.css"
import { baseUrl } from "../../utils/request";

//FC function
const Login: React.FC = () => {
    const navigate = useNavigate()
    useEffect(() => {
        // localStorage.clear()
        if (localStorage.getItem("isLogin") === '1') {
            navigate("/home/1/10/0")
        }
    }, [])
    return (
        <div className="login-page">
            {/* 新增：内容容器 - 包含登录框和图片 */}
            <div className="content-container">

                <div className="left-image">
                    <Image preview={false} width={550} src={baseUrl + "/img/1673510277800_586.png"}></Image>
                </div>
                <div className="login-form-container">
                    <LoginForm></LoginForm>
                </div>
            </div>
            {/* 备案号放在内容容器下方 */}
            <div className="icp-info">
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
                    京ICP备2024073807号
                </a>
            </div>
        </div>
    )
}

export default Login
